import React, { useCallback, useEffect } from 'react';
import { limitWordsAndSpaces } from '../utils/limitWordsAndSpaces';
import { Checkbox, Grid, TextField, Typography } from '@mui/material';

import {

    CheckCircle as CircleChecked,

    RadioButtonUnchecked as CircleUnchecked,

} from '@mui/icons-material';

import { partial, times } from 'lodash';

import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';

import ImagePicker from '@dyl/components/ImagePicker';

export default function TaskRadioImagesBlock({

    path = [''],
    hasCheckbox = true,
    isArcPublished = false,

}) {

    useEffect(() => {

        console.assert(!!path, 'No path specified!');

    }, [path]);

    const [array] = useTaskField(path);
    return (
        <Grid container spacing={2}>

            {times(array?.length, index => (

                <Grid item xs={12} key={index} alignItems={"center"}>

                    <Item parent={path} index={index} hasCheckbox={hasCheckbox} isArcPublished={isArcPublished} />

                </Grid>

            ))}

        </Grid>

    );

}

function Item({ parent, index, hasCheckbox, isArcPublished }) {

    const useField = partial(useTaskField, parent, index);

    const [, setItems] = useTaskField(parent);

    const [imageId, setImageId, imageError] = useField('image_id');

    const [isCorrect] = useField('is_correct_answer');

    const [description, setDescription] = useField('description');

    const setAsCorrect = useCallback(() => {

        setItems(prev => prev.map((a, i) => ({

            ...a,

            is_correct_answer: i === index,

        })));

    }, [index, setItems]);

const MAX_WORD_LIMIT = 27; // Change this to your desired max word count

const wordCount = (typeof description === 'string' ? description : '').trim().split(/\s+/).filter(Boolean).length;
const showCounter = true;


    const pictureNumber = index + 1;
    return (

        <div style={{ width: "840px", height: "210px", display: "flex", gap: "20px" }}>

            {hasCheckbox && (

                <Checkbox

                    checked={isCorrect}

                    onClick={setAsCorrect}

                    icon={<CircleUnchecked />}

                    checkedIcon={<CircleChecked />}

                    color='primary'

                />

            )}

            <div style={{ width: "320px", height: "210px" }}>

                <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>{`Picture ${pictureNumber}`}</Typography>

                <ImagePicker

                    label={`Picture ${pictureNumber}`}

                    value={imageId}

                    onChange={setImageId}
                    isArcPublished={isArcPublished}

                    fullWidth

                    error={!!imageError}

                    helperText={imageError ?? (hasCheckbox ? 'Select if key' : '')}

                />

            </div>

            <div style={{ width: "500px", height: "210px", position: 'relative' }}>

                <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }} noWrap>

                    {`Picture ${index + 1} description for AI AutoMarker`}

                </Typography>

           <TextField
  value={description}
  onChange={(e) => {
    const value = limitWordsAndSpaces(e.target.value, MAX_WORD_LIMIT);
    setDescription(value);
  }}
  variant="outlined"
  placeholder="Write here"
  multiline
  disabled={!isArcPublished}
  InputProps={{
    sx: {
      width: '500px',
      height: '180px',
      '& .MuiInputBase-inputMultiline': {
        height: '100% !important',
        overflow: 'auto'
      },
      '& .MuiInputBase-input::placeholder': {
        fontStyle: 'italic',
      }
    }
  }}
/>


               {showCounter && (
  <Typography
    sx={{
      position: 'absolute',
      bottom: 5,
      right: 3,
      padding: '4px 8px',
      fontWeight: '700',
      fontSize: '12px',
      color: 'text.primary',
    }}
  >
    Word count&nbsp;{wordCount} / {MAX_WORD_LIMIT}
  </Typography>
)}

            </div>

        </div>

    );

}

